import ParkingOccupancyTable from './ParkingOccupancyTable';

export default ParkingOccupancyTable;
